import { action, computed, makeObservable, observable } from 'mobx';

export interface WindowState<D extends Record<string, any>> {
  visible: boolean;
  data: D;
}

export interface IWindowController<D extends Record<string, any>>
  extends WindowState<D> {
  unwrap(): void;
  wrap(): void;
}

interface WindowControllerProps<D extends Record<string, any>> {
  defaultVisible?: boolean;
  data: D;
}

export class WindowController<D extends Record<string, any> = {}>
  implements IWindowController<D>
{
  @observable private _visible: boolean;

  readonly data: D;

  constructor(props: WindowControllerProps<D>) {
    const { defaultVisible = false, data } = props;

    this._visible = defaultVisible;
    this.data = data;

    makeObservable<WindowController<D>>(this);
  }

  @computed get visible(): boolean {
    return this._visible;
  }

  @action unwrap = () => {
    this._visible = true;
  };

  @action wrap = () => {
    this._visible = false;
  };
}
